import React from 'react';
import Reveal from 'react-awesome-reveal';
import { keyframes } from "@emotion/react";
import { BsChevronDoubleDown } from "react-icons/bs";
import { GrTwitter } from "react-icons/gr";
import { SiDiscord } from "react-icons/si";
import { Link } from '@reach/router';

const NavLink = props => (
  <Link 
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: isCurrent ? 'active' : 'non-active',
      };
    }}
  />
);
const fadeInUp = keyframes`
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
`;
const inline = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
  .d-inline{
    display: inline-block;
   }
`;

const slidermainparticle= () => (
 <div className="container">
    <div className="row align-items-center">
          <div className="col-md-6">
              <div className="spacer-single"></div>
              <h4> <span className="text-uppercase color">Merry Terra Christmas</span></h4>
              <Reveal className='onStep' keyframes={fadeInUp} delay={300} duration={900} triggerOnce>
              <h1 className="col-white">Collect Your <br/>Christmas Seals NFTs!<br/> Right Now!</h1>
              </Reveal>
              <Reveal className='onStep' keyframes={fadeInUp} delay={600} duration={900} triggerOnce>
              <h5 className="lead col-white">
              MTC seals are 3,600+ unique Christmas Seals with proof of ownership stored on the Terra blockchain. 80% of mint proceeds will be donated to the the Solar Electric Light Fund(SELF) via Angel Protocol. SELF is a initiative to design and implement solar projects for disadvantaged communities around the world. (Minting is only available on the desktop version.)
              </h5>
              </Reveal>
              <div className="spacer-10"></div>
              <Reveal className='onStep d-inline' keyframes={inline} delay={800} duration={900} triggerOnce>
              <NavLink to="/minting"><p onClick={()=> window.open("#", "_self")} className="btn-main1 inline lead">Mint Now!</p></NavLink>
              <NavLink to="/explore"><p onClick={()=> window.open("#", "_self")} className="btn-main2 inline lead">Explore</p></NavLink>
              <a href="https://twitter.com/MTC_Terra" target="_blank"><GrTwitter className='icon' size={36} color="white"></GrTwitter></a>
              <a href="https://discord.com/invite/DvdyxNwWTh" target="_blank"><SiDiscord className='icon' size={36} color="white"></SiDiscord></a>
              <div className="mb-sm-30"></div>
              </Reveal>
              <Reveal className='onStep d-inline' keyframes={inline} delay={900} duration={1200} triggerOnce>
              <div className="row">
                  <div className="spacer-single"></div>
                  <div className="row">
                          <div className="col-lg-4 col-md-6 col-sm-4 mb30">
                              <div className="de_count text-left">
                                  <h3><span>3,600+</span></h3>
                                  <h4 className="id-color" >Collectibles</h4>
                              </div>
                          </div>

                          <div className="col-lg-4 col-md-6 col-sm-4 mb30">
                              <div className="de_count text-left">
                                  <h3><span>1,000+</span></h3>
                                  <h4 className="id-color">Followers</h4>
                              </div>
                          </div>

                          <div className="col-lg-4 col-md-6 col-sm-4 mb30">
                              <div className="de_count text-left">
                                  <h3><span>2,850</span>Luna</h3>
                                  <h4 className="id-color">Donation amount.</h4>
                              </div>
                          </div>
                      </div>
              </div>
              </Reveal>
          </div>
          <div className="col-md-6 xs-hide">
          <Reveal className='onStep d-inline' keyframes={inline} delay={300} duration={1200} triggerOnce>
              <img src="./img/misc/santa.png" className="img-fluid" alt=""/>
          </Reveal>

          </div>
      </div>
    </div>
);
export default slidermainparticle;